module.exports = __webpack_public_path__ + "assets/img/landing-apva.9708fcd1.jpg";